import React, { Suspense } from 'react'
import { I18nextProvider } from 'react-i18next'

import Loading from './components/shared/loading/Loading'
import ThemeWrapper from './ThemeWrapper'
import i18n from './i18n'
import { logAppVersion } from './util/log.helpers'
import WalletConnectWrapper from './components/walletConnect/WalletConnectWrapper'
import App from './App'

logAppVersion()

const Root = () => {
  return (
    <Suspense fallback={<Loading />}>
      <ThemeWrapper>
        <I18nextProvider i18n={i18n}>
          <WalletConnectWrapper>
            <App />
          </WalletConnectWrapper>
        </I18nextProvider>
      </ThemeWrapper>
    </Suspense>
  )
}

export default Root
